// Instacut — default welcome-message templates for the shop booking page.
// Used by /admin/onboard and /welcome. Templates are seeds — the user
// is expected to edit them further in the textarea after picking one.
//
// `{shop}` is replaced with the shop's name (falls back to "our shop").

export const WELCOME_TEMPLATES = [
  {
    id: 'classic',
    label: 'Classic barbershop',
    text: 'Welcome to {shop}. Traditional cuts, hot towel shaves and a proper old-school finish. Book your chair below.',
  },
  {
    id: 'warm',
    label: 'Warm & welcoming',
    text: "You're in good hands at {shop}. Grab a coffee, take a seat, and leave sharper than you came in.",
  },
  {
    id: 'modern',
    label: 'Modern & premium',
    text: 'Precision fades, skin fades and modern styling at {shop}. Book online in under 60 seconds.',
  },
  {
    id: 'family',
    label: 'Family-friendly',
    text: 'Cuts for gents, lads and little ones at {shop}. Friendly chairs, no fuss, and a proper finish every time.',
  },
  {
    id: 'fast',
    label: 'Fast & convenient',
    text: 'Skip the queue at {shop}. Book your slot, walk straight to your chair, and be back on the road in half an hour.',
  },
  {
    id: 'beard',
    label: 'Beard specialist',
    text: 'Cuts, beard sculpting and hot towel shaves at {shop}. Trusted for beards that deserve better.',
  },
];

export const fillWelcomeTemplate = (templateId, shopName) => {
  const t = WELCOME_TEMPLATES.find((x) => x.id === templateId);
  if (!t) return '';
  const safeName = (shopName || '').trim() || 'our shop';
  return t.text.replaceAll('{shop}', safeName);
};
